import script from "./ConsultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultModal.vue?vue&type=script&setup=true&lang=js"

import "./ConsultModal.vue?vue&type=style&index=0&id=6d4d10a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4d10a4"]])

export default __exports__